import React from "react";

interface PartnerTermsAcceptanceFormProps {
  partnerName: string;
  termsVersion: string;
  agreed: boolean;
  onAgreedChange: (agreed: boolean) => void;
  onAccept: () => void;
  isSubmitting: boolean;
}

/** The checkbox + accept button shown until the partner has accepted the current terms. */
const PartnerTermsAcceptanceForm: React.FC<PartnerTermsAcceptanceFormProps> = ({
  partnerName,
  termsVersion,
  agreed,
  onAgreedChange,
  onAccept,
  isSubmitting,
}) => {
  return (
    <div className="with-border mt-8 rounded-2xl bg-white p-4 lg:p-6 dark:bg-primary-10">
      <label className="flex cursor-pointer items-start gap-3">
        <input
          type="checkbox"
          checked={agreed}
          onChange={(event) => onAgreedChange(event.target.checked)}
          className="mt-1 h-5 w-5 shrink-0 accent-primary-40"
        />
        <span className="text-sm text-grey-20 dark:text-grey-80">
          I, {partnerName}, have read the Referral Partner Terms (version {termsVersion}) and
          agree to them.
        </span>
      </label>
      <button
        type="button"
        className="btn btn-primary mt-4 disabled:cursor-not-allowed disabled:opacity-50"
        disabled={!agreed || isSubmitting}
        onClick={onAccept}
      >
        {isSubmitting ? "Accepting…" : "Accept the terms"}
      </button>
    </div>
  );
};

export default PartnerTermsAcceptanceForm;
